import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
import { encodeSortList, SortListDecoder } from './SortList.js';
export class StamhoofdFilterJSONDecoder {
    static encode(filter, context) {
        return JSON.stringify(StamhoofdFilterDecoder.encode(filter, context));
    }
    static decode(data) {
        const str = data.string;
        try {
            const decoded = JSON.parse(str);
            return StamhoofdFilterDecoder.decode(data.clone({ data: decoded, field: data.currentField, context: data.context }));
        }
        catch (e) {
            throw new SimpleError({
                code: 'invalid_field',
                message: `Expected JSON at ${data.currentField}`,
                field: data.currentField,
            });
        }
    }
}
export class StamhoofdFilterDecoder {
    static encode(filter, context) {
        // We need to convert all Date objects to something recornizable so we can decode them as Dates too
        // We'll use magic objects for this: { $: '$date', value: unixtimeinms }
        if (filter instanceof Date) {
            return { $: '$date', value: filter.encode(context) };
        }
        if (filter === null) {
            return null;
        }
        if (Array.isArray(filter)) {
            return filter.map(f => this.encode(f, context));
        }
        if (typeof filter === 'object') {
            // Loop and replace all keys
            const c = {};
            for (const [key, value] of Object.entries(filter)) {
                c[key] = this.encode(value, context);
            }
            return c;
        }
        return filter;
    }
    static decode(data) {
        const value = data.value;
        if (value === null) {
            return null;
        }
        if (Array.isArray(value)) {
            return value.map((v, index) => this.decode(data.clone({
                data: v,
                field: data.addToCurrentField(index),
                context: data.context,
            })));
        }
        if (typeof value === 'object') {
            // Check if it's a date
            if ('$' in value && value.$ === '$date' && 'value' in value) {
                return DateDecoder.decode(data.clone({
                    data: value.value,
                    field: data.addToCurrentField('value'),
                    context: data.context,
                }));
            }
            // Loop and replace all keys
            const c = {};
            for (const [key, v] of Object.entries(value)) {
                c[key] = this.decode(data.clone({
                    data: v,
                    field: data.addToCurrentField(key),
                    context: data.context,
                }));
            }
            return c;
        }
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return value;
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Invalid filter at ${data.currentField}`,
            field: data.currentField,
        });
    }
}
export class CountResponse extends AutoEncoder {
}
__decorate([
    field({ decoder: IntegerDecoder })
], CountResponse.prototype, "count", void 0);
export class CountFilteredRequest {
    constructor(data) {
        var _a, _b;
        this.filter = (_a = data.filter) !== null && _a !== void 0 ? _a : null;
        this.search = (_b = data.search) !== null && _b !== void 0 ? _b : null;
    }
    static decode(data) {
        var _a, _b;
        return new CountFilteredRequest({
            filter: (_a = data.optionalField('filter')) === null || _a === void 0 ? void 0 : _a.nullable(StamhoofdFilterJSONDecoder),
            search: (_b = data.optionalField('search')) === null || _b === void 0 ? void 0 : _b.nullable(StringDecoder),
        });
    }
    encode(context) {
        var _a;
        return {
            filter: this.filter ? StamhoofdFilterJSONDecoder.encode(this.filter, context) : undefined,
            search: (_a = this.search) !== null && _a !== void 0 ? _a : undefined,
        };
    }
}
export class LimitedFilteredRequest {
    constructor(data) {
        var _a, _b, _c, _d;
        this.filter = (_a = data.filter) !== null && _a !== void 0 ? _a : null;
        this.pageFilter = (_b = data.pageFilter) !== null && _b !== void 0 ? _b : null;
        this.sort = (_c = data.sort) !== null && _c !== void 0 ? _c : [];
        this.limit = data.limit;
        this.search = (_d = data.search) !== null && _d !== void 0 ? _d : null;
    }
    static decode(data) {
        var _a, _b, _c;
        return new LimitedFilteredRequest({
            filter: (_a = data.optionalField('filter')) === null || _a === void 0 ? void 0 : _a.nullable(StamhoofdFilterJSONDecoder),
            pageFilter: (_b = data.optionalField('pageFilter')) === null || _b === void 0 ? void 0 : _b.nullable(StamhoofdFilterJSONDecoder),
            sort: data.field('sort').decode(SortListDecoder),
            limit: data.field('limit').integer,
            search: (_c = data.optionalField('search')) === null || _c === void 0 ? void 0 : _c.nullable(StringDecoder),
        });
    }
    encode(context) {
        var _a;
        return {
            filter: this.filter ? StamhoofdFilterJSONDecoder.encode(this.filter, context) : undefined,
            pageFilter: this.pageFilter ? StamhoofdFilterJSONDecoder.encode(this.pageFilter, context) : undefined,
            sort: encodeSortList(this.sort),
            limit: this.limit,
            search: (_a = this.search) !== null && _a !== void 0 ? _a : undefined,
        };
    }
}
//# sourceMappingURL=FilteredRequest.js.map